/**
 * Service Hero: the background video (Figma's video fill). Nothing downloads until the hero is on screen above 768px
 * wide; it plays only there, with the tab visible, and never with reduced motion or ?still. The poster image stays
 * below, so the video fades in once it really plays (data-playing).
 */

const WIDE = '(min-width: 769px)'; // the theme's tablet-v: is ≤ 768 (legacy's Elementor didn't play it on phones)
const STILL = window.matchMedia('(prefers-reduced-motion: reduce)').matches || new URLSearchParams(window.location.search).has('still');

function background(wrapper: HTMLElement, video: HTMLVideoElement): void {
	const wide = window.matchMedia(WIDE);
	let loaded = false;
	let inView = false;
	const update = (): void => {
		if (!inView || document.hidden || !wide.matches) {
			if (!video.paused) {
				video.pause();
			}
			return;
		}
		if (!loaded) {
			video.querySelectorAll<HTMLSourceElement>('source[data-src]').forEach((source) => {
				source.src = source.dataset.src || '';
			});
			video.load();
			loaded = true;
		}
		if (video.paused) {
			video.play().catch(() => {});
		}
	};
	video.addEventListener('playing', () => video.setAttribute('data-playing', ''), { once: true });
	new IntersectionObserver((entries) => {
		inView = entries[entries.length - 1].isIntersecting;
		update();
	}).observe(wrapper);
	document.addEventListener('visibilitychange', update);
	wide.addEventListener('change', update);
}

document.querySelectorAll<HTMLElement>('[data-px-block="service-hero"]').forEach((wrapper) => {
	const video = wrapper.querySelector<HTMLVideoElement>('[data-service-hero-video]');
	if (video && !STILL) {
		background(wrapper, video);
	}
});
